module.exports = __webpack_public_path__ + "31cef6bda7b48f304d5846dc55c81f74.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-medium.woff
 ** module id = 12
 ** module chunks = 0
 **/